/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerifyProjectLockResponse } from '../../models/verify-project-lock-response';

export interface ProjectsControllerVerifyProjectLock$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerVerifyProjectLock(http: HttpClient, rootUrl: string, params: ProjectsControllerVerifyProjectLock$Params, context?: HttpContext): Observable<StrictHttpResponse<VerifyProjectLockResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerVerifyProjectLock.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VerifyProjectLockResponse>;
    })
  );
}

projectsControllerVerifyProjectLock.PATH = '/planning-projects/v1/projects/{id}/lock';
